import MergeIcon from "@mui/icons-material/MergeRounded";
import { Alert, Button, Stack, Typography } from "@mui/material";

import { useTranslation } from "@/translations";

interface Props {
  selectedCount: number;
  isValidSelection: boolean;
  hasMixedTypes: boolean;
  onClearSelection: () => void;
  onStartMerge: () => void;
}

export function MergeSelectionBar({
  selectedCount,
  isValidSelection,
  hasMixedTypes,
  onClearSelection,
  onStartMerge,
}: Props) {
  const { t } = useTranslation();

  return (
    <Alert
      severity={hasMixedTypes ? "warning" : "info"}
      sx={{
        display: "flex",
        alignItems: "center",
        border: 1,
        borderColor: hasMixedTypes ? "warning.light" : "info.light",
        "& .MuiAlert-message": {
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
        },
      }}
    >
      <Stack direction="row" spacing={2} alignItems="center">
        <Typography variant="body2" fontWeight={600} color="text.primary">
          {t("proceedingParticipants.merge.selectionCount", { count: selectedCount })}
        </Typography>
        {hasMixedTypes && (
          <Typography variant="body2" color="warning.main">
            {t("proceedingParticipants.merge.differentTypesHint")}
          </Typography>
        )}
      </Stack>
      <Stack direction="row" spacing={2} alignItems="center">
        <Button variant="text" onClick={onClearSelection}>
          {t("proceedingParticipants.merge.clearSelection")}
        </Button>
        <Button variant="contained" startIcon={<MergeIcon />} onClick={onStartMerge} disabled={!isValidSelection}>
          {t("proceedingParticipants.merge.confirmButton")}
        </Button>
      </Stack>
    </Alert>
  );
}
